import { computed, reactive } from 'vue';
import { PurchaseOption, PurchaseOptionType } from '@/types/productServerApi';

const state: any = reactive({
    userSelectedPurchaseOptionTypeRef: null,
});

export default function useProductPurchase() {
    const getUserSelectedPurchaseOptionType = computed(() => {
        return state.userSelectedPurchaseOptionType;
    });

    function setUserSelectedPurchaseOptionType(optionType: PurchaseOptionType) {
        state.userSelectedPurchaseOptionType = optionType;
    }

    const getPreferredPurchaseOptionType = (
        purchaseOptions: PurchaseOption[],
        parentProductPurchaseOptionType: PurchaseOptionType | null,
        relevantStoreId: string | null,
        basketHasClickAndCollect: boolean = false,
        basketHasInstant: boolean = false): PurchaseOptionType | null => {
        const purchaseOptionMatchingParentProduct = purchaseOptions.find((purchaseOption) => purchaseOption.type === parentProductPurchaseOptionType);
        const parentPurchaseOptionIsAvailable = !!purchaseOptionMatchingParentProduct;
        const instantPurchaseOption = purchaseOptions.find((option) => option.type === PurchaseOptionType.Instant);
        const clickAndCollectPurchaseOption = purchaseOptions.find((option) => option.type === PurchaseOptionType.ClickAndCollect);
        const otherAvailablePurchaseOptions = purchaseOptions.find((option) => option.type !== PurchaseOptionType.ClickAndCollect);

        if (parentPurchaseOptionIsAvailable) {
            return purchaseOptionMatchingParentProduct.type;
        }

        if (!!instantPurchaseOption && basketHasInstant) {
            return instantPurchaseOption.type;
        }

        if (!!clickAndCollectPurchaseOption && basketHasClickAndCollect) {
            return clickAndCollectPurchaseOption.type;
        }

        if (otherAvailablePurchaseOptions) {
            return otherAvailablePurchaseOptions.type;
        }

        if (clickAndCollectPurchaseOption && relevantStoreId) {
            return clickAndCollectPurchaseOption.type;
        }

        return null;
    };

    return {
        getUserSelectedPurchaseOptionType,
        setUserSelectedPurchaseOptionType,
        getPreferredPurchaseOptionType,
    };
}
